export var RoleInstallationMethod;
(function (RoleInstallationMethod) {
    RoleInstallationMethod["INSTALLATION_METHOD_UNKNOWN"] = "UNKNOWN_METHOD";
    RoleInstallationMethod["INSTALLATION_METHOD_CLOUDFORMATION"] = "CLOUDFORMATION";
    RoleInstallationMethod["INSTALLATION_METHOD_TERRAFORM"] = "TERRAFORM";
    RoleInstallationMethod["INSTALLATION_METHOD_BASH_SCRIPT"] = "BASH_SCRIPT";
})(RoleInstallationMethod || (RoleInstallationMethod = {}));
